import { useContent } from '../context/ContentContext';
import { LoadingState } from '../components/LoadingState';
import { ErrorState } from '../components/ErrorState';
import { HighLevelIssueCard } from '../components/HighLevelIssueCard';

export function ExplorePage() {
  const { data, loading, error, reload } = useContent();

  if (loading) return <LoadingState />;
  if (error || !data) return <ErrorState message={error ?? 'No data'} onRetry={reload} />;

  return (
    <div className="page explore-page">
      <header className="page-header">
        <h1>Voter issue categories</h1>
        <p>
          Content is organized by {data.stats.highLevelIssueCount} high-level issues voters care
          about, then broken into {data.stats.specificIssueCount} specific subtopics. The same
          entry may appear under multiple issues when it touches more than one concern.
        </p>
      </header>
      <div className="section-grid">
        {data.highLevelIssues.map((issue, i) => (
          <HighLevelIssueCard key={issue.id} issue={issue} index={i} variant="visual" />
        ))}
      </div>
    </div>
  );
}
